// src/components/Customer/EditCustomerModal.jsx
import React, { useState, useEffect } from 'react';

const EditCustomerModal = ({ isOpen, onClose, onSave, customer, isSaving, routes = [] }) => {
  const [formData, setFormData] = useState({
    name: '', shopName: '', lane: '', town: '', province: '',
    contactNumber: '', email: '', birthday: '', creditLimit: '',
    lat: '', lon: '', routeId: '', isActive: true
  });

  useEffect(() => {
    if (customer && isOpen) {
      // Ensure routeId is always a string for proper select value matching
      const routeId = String(customer.routeId || customer.route?.id || '');
      
      console.log('Customer object:', customer); // Debug
      console.log('Routes available:', routes); // Debug
      console.log('Customer routeId:', routeId); // Debug
      
      setFormData({
        name: customer.name || '',
        shopName: customer.shopName || '',
        lane: customer.lane || '',
        town: customer.town || '',
        province: customer.province || '',
        contactNumber: customer.contactNumber || '',
        email: customer.email || '',
        birthday: customer.birthday || '',
        creditLimit: customer.creditLimit ?? '',
        lat: customer.lat ?? '',
        lon: customer.lon ?? '',
        routeId: routeId,
        isActive: Boolean(customer.isActive),
      });
    }
  }, [customer, isOpen, routes]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name.trim() || !formData.shopName.trim() || !formData.contactNumber.trim() || !formData.routeId) {
      alert('Please fill required fields');
      return;
    }

    const payload = {
      name: formData.name,
      shopName: formData.shopName,
      lane: formData.lane,
      town: formData.town,
      province: formData.province,
      contactNumber: formData.contactNumber,
      email: formData.email,
      birthday: formData.birthday,
      creditLimit: parseFloat(formData.creditLimit) || 0,
      lat: parseFloat(formData.lat) || 0,
      lon: parseFloat(formData.lon) || 0,
      routeId: parseInt(formData.routeId), // Convert to number when sending
      isActive: Boolean(formData.isActive),
    };

    console.log('Form data:', formData); // Debug
    console.log('Payload before sending:', JSON.stringify(payload, null, 2)); // Debug
    console.log('RouteId type:', typeof payload.routeId, 'Value:', payload.routeId); // Debug
    onSave(payload);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <header className="modal-header">
          <h3>Edit Customer: {customer?.name}</h3>
          <button className="close-modal-btn" onClick={onClose} disabled={isSaving}>×</button>
        </header>
        <div className="modal-body">
          <form id="editCustomerForm" onSubmit={handleSubmit}>
            <div className="form-grid-modal">
              <label>Name *</label>
              <input name="name" className="custom-input" value={formData.name} onChange={handleChange} required disabled={isSaving} />
              
              <label>Shop Name *</label>
              <input name="shopName" className="custom-input" value={formData.shopName} onChange={handleChange} required disabled={isSaving} />
              
              <label>Lane</label>
              <input name="lane" className="custom-input" value={formData.lane} onChange={handleChange} disabled={isSaving} />
              
              <label>Town</label>
              <input name="town" className="custom-input" value={formData.town} onChange={handleChange} disabled={isSaving} />
              
              <label>Province</label>
              <input name="province" className="custom-input" value={formData.province} onChange={handleChange} disabled={isSaving} />
              
              <label>Contact Number *</label>
              <input name="contactNumber" className="custom-input" value={formData.contactNumber} onChange={handleChange} required disabled={isSaving} />
              
              <label>Email</label>
              <input name="email" type="email" className="custom-input" value={formData.email} onChange={handleChange} disabled={isSaving} />
              
              <label>Birthday</label>
              <input name="birthday" type="date" className="custom-input" value={formData.birthday} onChange={handleChange} disabled={isSaving} />
              
              <label>Credit Limit</label>
              <input name="creditLimit" type="number" className="custom-input" value={formData.creditLimit} onChange={handleChange} disabled={isSaving} />
              
              <label>Latitude</label>
              <input name="lat" type="number" step="any" className="custom-input" value={formData.lat} onChange={handleChange} disabled={isSaving} />
              
              <label>Longitude</label>
              <input name="lon" type="number" step="any" className="custom-input" value={formData.lon} onChange={handleChange} disabled={isSaving} />
              
              <label>Route *</label>
              <select name="routeId" className="custom-select" value={formData.routeId} onChange={handleChange} required disabled={isSaving}>
                <option value="">Select Route</option>
                {routes.map(route => (
                  <option key={route.id || route.routeId} value={String(route.id || route.routeId)}>
                    {route.name}
                  </option>
                ))}
              </select>
              
              <label>Active</label>
              <input type="checkbox" name="isActive" checked={formData.isActive} onChange={handleChange} disabled={isSaving} />
            </div>
          </form>
        </div>
        <footer className="modal-footer">
          <button className="btn btn-cancel" onClick={onClose} disabled={isSaving}>Cancel</button>
          <button className="btn btn-save" type="submit" form="editCustomerForm" disabled={isSaving}>
            {isSaving ? 'Saving...' : 'Update Customer'}
          </button>
        </footer>
      </div>
    </div>
  );
};

export default EditCustomerModal;